import React from "react";
import IUser from "../types/user.type";
import AuthService from "../services/auth.service";
import LeaveService from "../services/leave.service";
import ILeave from "../types/leave.type";
import moment from "moment";
import {toast, ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import IPayroll from "../types/payroll.type";
import PayService from "../services/pay.service";
import IOvertime from "../types/overtime.type";
import OvertimeService from "../services/overtime.service";

type Props = {
    selectMonth: Date,
    email: string,
}

type State = {
    isModerator: boolean,
    isAdmin: boolean,
    currentUser: IUser,
    selectMonth: Date,
    email: string,
    OTRequests: IOvertime[],
    newOTRequest: IOvertime
}

export default class UserOvertime extends React.Component<Props, State> {
    constructor(props: any) {
        super(props);
        this.state = {
            isModerator: false,
            isAdmin: false,
            currentUser: {} as IUser,
            selectMonth: this.props.selectMonth,
            email: this.props.email,
            OTRequests: [] as IOvertime[],
            newOTRequest: {
                date: moment().format("YYYY-MM-DD"),
                ot_hour: 1
            } as IOvertime
        };
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleChangeReason = this.handleChangeReason.bind(this);
        this.handleChangeDate = this.handleChangeDate.bind(this);
        this.handleChangeOTTime = this.handleChangeOTTime.bind(this);
    }

    componentDidMount = () => {
        const user = AuthService.getCurrentUser();
        if (user) {
            this.setState({
                currentUser: user,
                isModerator: user.roles?.includes("ROLE_MODERATOR"),
                isAdmin: user.roles?.includes("ROLE_ADMIN"),
            });
        }
    };

    componentDidUpdate = () => {
        if (this.state.selectMonth != this.props.selectMonth) {
            this.setState({
                selectMonth: this.props.selectMonth
            });
            this.updateData();
        }
    };

    updateData() {
        const queryParams = new URLSearchParams(window.location.search);
        const email = queryParams.get("email");
        if (this.props.email == "all") {
            OvertimeService.getAllOvertimeRequests(this.props.selectMonth.getMonth() + 1, this.props.selectMonth.getFullYear()).then(
                (a: IOvertime[]) => {
                    this.setState({
                        OTRequests: a
                    });
                }
            );
        } else {
            OvertimeService.getOvertimeRequests(email != null && email != "" ? email : this.state.currentUser?.email!, this.props.selectMonth.getMonth() + 1, this.props.selectMonth.getFullYear()).then(
                (a: IOvertime[]) => {
                    this.setState({
                        OTRequests: a
                    });
                }
            );
        }
    };

    ShowHeader() {
        if (this.state.email == "all") {
            return (<tr>
                <th data-toggle="true" className="footable-visible footable-first-column footable-sortable">Name</th>
                <th className="footable-visible footable-sortable">Date</th>
                <th className="footable-visible footable-sortable">Multiplier</th>
                <th className="footable-visible footable-sortable">Time</th>
                <th data-hide="phone" className="footable-visible footable-sortable">Tasks</th>
                <th data-hide="phone" className="footable-visible footable-sortable">Status</th>
                <th data-hide="phone" className="footable-visible footable-last-column footable-sortable">Actions</th>
            </tr>)
        } else {
            return (<tr>
                <th data-toggle="true" className="footable-visible footable-first-column footable-sortable">Date</th>
                <th className="footable-visible footable-sortable">Multiplier</th>
                <th className="footable-visible footable-sortable">Time</th>
                <th data-hide="phone" className="footable-visible footable-sortable">Tasks</th>
                <th data-hide="phone" className="footable-visible footable-sortable">Status</th>
                <th data-hide="phone" className="footable-visible footable-last-column footable-sortable">Actions</th>
            </tr>)
        }
    }

    ShowStatus = (leave: IOvertime) => {
        if (leave.approve == 0) {
            return (<span className="label label-danger font-weight-100">Declined</span>);
        } else if (leave.approve == 1) {
            return (
                <>
                    <span className="label label-success font-weight-100">Approved
                        < br/>
                        <small> by {leave.approver?.replace("@bbold.vn", "")}</small>
                    </span>
                </>);
        } else {
            return (<span className="label label-warning font-weight-100">Awaiting</span>);
        }
    };

    ShowActions = (leave: IOvertime) => {
        // if (leave.approve == -1) {
        return (<>
            {leave.approve != 1 && <button className="btn btn-sm btn-rounded btn-success"
                                           onClick={() => this.ApproveRequest(leave, true)}>Approve
            </button>}
            {leave.approve != 0 && <button className="btn btn-sm btn-rounded btn-outline-danger m-l-10"
                                           onClick={() => this.ApproveRequest(leave, false)}>Decline
            </button>}
            <button data-toggle="modal" data-target="#request-leave-modal"
                    className="btn btn-sm btn-rounded btn-outline-info m-l-10"
                    onClick={() => this.UpdateRequest(leave)}>Update
            </button>
            <button data-toggle="modal" data-target="#delete-request-leave-modal"
                    className="btn btn-sm btn-rounded btn-danger m-l-10"
                    onClick={() => this.ConfirmDeleteRequest(leave)}>Delete
            </button>
        </>);
        /*} else {
            return (<>
                <button className="btn btn-sm btn-circle btn-success" data-toggle="tooltip" data-placement="top"
                        title="Approve"
                        onClick={() => this.ApproveRequest(leave, true)}><i className="fa fa-check"></i>
                </button>
                <button className="btn btn-sm btn-circle btn-outline-danger m-l-10" data-toggle="tooltip"
                        data-placement="top" title="Decline"
                        onClick={() => this.ApproveRequest(leave, false)}><i className="fa fa-minus"></i>
                </button>
                <button data-toggle="modal" data-target="#request-leave-modal"
                        className="btn btn-sm btn-circle btn-outline-info m-l-10"
                        onClick={() => this.UpdateRequest(leave)}><i className="fa fa-pencil"></i>
                </button>
                <button data-toggle="modal" data-target="#delete-request-leave-modal"
                        className="btn btn-sm btn-circle btn-danger m-l-10"
                        onClick={() => this.ConfirmDeleteRequest(leave)}><i className="fa fa-remove"></i>
                </button>
                {/!*<span> by {leave.approver?.replace("@bbold.vn", "")}</span>*!/}
            </>);
        }*/
    };

    ApproveRequest = (leave: IOvertime, approve: boolean) => {
        OvertimeService.approve(leave.id!, this.state.currentUser.email, approve ? 1 : 0).then(
            (result) => {
                window.location.reload();
            }
        );
    };

    UpdateRequest = (leave: IOvertime) => {
        this.setState({
            newOTRequest: leave
        });
    };

    ConfirmDeleteRequest = (leave: IOvertime) => {
        this.setState({
            newOTRequest: leave
        });
    };

    DeleteRequest = () => {
        OvertimeService.delete(this.state.newOTRequest.id!).then(
            (result) => {
                window.location.reload();
            }
        );
    };

    CreateLink = (isAdmin: boolean, email: string, name: string) => {
        if (isAdmin) {
            return (<a href={"/user?email=" + email}><span>{name}</span></a>);
        } else {
            return (<span>{name}</span>);
        }
    };

    ShowMultiplierTag = (multiplier: number) => {
        if (multiplier == 2) {
            return (<span className="label label-purple label-rounded">200%</span>);
        } else if (multiplier == 3) {
            return (<span className="label label-danger label-rounded">300%</span>);
        }
        return (<span className="label label-success label-rounded">150%</span>);
    }

    ShowTable() {
        const {OTRequests, email, isAdmin} = this.state;
        if (OTRequests != null) {
            if (email == "all") {
                return OTRequests.map((att, i) => (
                    <tr key={att.id}>
                        <td>{this.CreateLink(isAdmin, att.email!, att.name!)}</td>
                        <td>{moment(att.date).format("ddd, MMM DD")}</td>
                        <td>{this.ShowMultiplierTag(att.multiplier!)}</td>
                        <td>{att.ot_hour} hours</td>
                        <td>{att.reason}</td>
                        <td>{this.ShowStatus(att)}</td>
                        <td>{this.ShowActions(att)}</td>
                    </tr>
                ))
            } else {
                return OTRequests.map((att, i) => (
                    <tr key={att.id}>
                        <td> {moment(att.date).format("ddd, MMM DD")}</td>
                        <td>{this.ShowMultiplierTag(att.multiplier!)}</td>
                        <td>{att.ot_hour} hours</td>
                        <td>{att.reason}</td>
                        <td>{this.ShowStatus(att)}</td>
                        <td>{this.ShowActions(att)}</td>
                    </tr>
                ))
            }
        }
    };

    ShowTag = (approve: number) => {
        if (approve == 0) {
            return (<span className="pull-right label label-danger label-rounded">Declined</span>);
        } else if (approve == 1) {
            return (<span className="pull-right label label-success label-rounded">Approved</span>);
        } else {
            return (<span className="pull-right label label-warning label-rounded">Awaiting</span>);
        }
    };

    ShowRequests = () => {
        const {OTRequests} = this.state;
        if (OTRequests != null) {
            return OTRequests.map((att, i) => (
                <div style={{cursor: "pointer"}} data-toggle="modal" data-target="#update-request-leave-modal"
                     onClick={() => this.UpdateRequest(att)}>
                    <div className="card-body p-0">
                        {this.ShowTag(att.approve!)}
                        <h5 className="card-title text-bold">{moment(att.date).format("ddd, MMM DD")}</h5>
                        <small className="pull-right">Show Detail</small>
                        <h5 className="card-subtitle text-bold">{att.ot_hour!} hours</h5>
                    </div>
                    <hr/>
                </div>
            ))
        }
    };

    ShowOTRequestDetail = (id: number) => {
        console.log("show detail: " + id);
    };

    ShowToast = (message: string) => {
        toast.error(message, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        });
    };

    handleSubmit: React.FormEventHandler<HTMLFormElement> = (event) => {
        event.preventDefault();
        const {currentUser, newOTRequest} = this.state;
        if (newOTRequest.date == null) {
            this.ShowToast("Date can not be empty!");
            return;
        }
        if (newOTRequest.reason == null) {
            this.ShowToast("Reason can not be empty!");
            return;
        }
        OvertimeService.request(currentUser.id!, currentUser.email!, newOTRequest.date!, newOTRequest.month!, newOTRequest.year!, newOTRequest.ot_hour!, newOTRequest.reason!).then(
            (result) => {
                if (result['code'] == 0) {
                    //close modal
                    window.location.reload();
                } else {
                }
            });
    };

    handleUpdate: React.FormEventHandler<HTMLFormElement> = (event) => {
        event.preventDefault();
        const {currentUser, newOTRequest} = this.state;
        if (newOTRequest.date == null) {
            this.ShowToast("Date can not be empty!");
            return;
        }
        if (newOTRequest.reason == null) {
            this.ShowToast("Reason can not be empty!");
            return;
        }
        OvertimeService.update(currentUser.email!, newOTRequest.id!, newOTRequest.date!, newOTRequest.month!, newOTRequest.year!, newOTRequest.ot_hour!, newOTRequest.reason!).then(
            (result) => {
                if (result['code'] == 0) {
                    //close modal
                    window.location.reload();
                } else {
                }
            });
    };

    handleChangeReason(event: React.ChangeEvent<HTMLInputElement>) {
        let newOTRequest = this.state.newOTRequest;
        newOTRequest.reason = event.target.value;
        this.setState({
            newOTRequest: newOTRequest
        });
    }

    handleChangeDate(event: React.ChangeEvent<HTMLInputElement>) {
        let newOTRequest = this.state.newOTRequest;
        newOTRequest.date = event.target.value;
        this.setState({
            newOTRequest: newOTRequest
        });
    }

    handleChangeOTTime(event: React.ChangeEvent<HTMLSelectElement>) {
        let newOTRequest = this.state.newOTRequest;
        newOTRequest.ot_hour = Number(event.target.value);
        this.setState({
            newOTRequest: newOTRequest
        });
    }

    render() {
        const {newOTRequest, email, currentUser} = this.state;
        if (email == "all") {
            return (
                <div>
                    <ToastContainer
                        position="top-right"
                        autoClose={5000}
                        hideProgressBar={false}
                        newestOnTop={false}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                    />
                    <div className="table-responsive">
                        <table className="table m-b-0 toggle-arrow-tiny color-table muted-table">
                            <thead>
                            {this.ShowHeader()}
                            </thead>
                            <tbody>
                            {this.ShowTable()}
                            </tbody>
                        </table>
                    </div>
                    <div id="delete-request-leave-modal" className="modal fade" role="dialog"
                         aria-labelledby="deleteLeaveModal" aria-hidden="true">
                        <div className="modal-dialog">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h4 className="modal-title">Delete Request</h4>
                                    <button type="button" className="close" data-dismiss="modal"
                                            aria-hidden="true">×
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <span>Do you want to delete this request?</span>
                                </div>
                                <div className="modal-footer">
                                    <button type="button" onClick={() => this.DeleteRequest()}
                                            className="btn btn-danger waves-effect waves-light">Delete
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div id="request-leave-modal" className="modal fade" role="dialog"
                         aria-labelledby="requestLeaveModal" aria-hidden="true">
                        <form className="form-horizontal form-material" onSubmit={this.handleUpdate}>
                            <div className="modal-dialog">
                                <div className="modal-content">
                                    <div className="modal-header">
                                        <h4 className="modal-title">Update OT Request</h4>
                                        <button type="button" className="close" data-dismiss="modal"
                                                aria-hidden="true">×
                                        </button>
                                    </div>
                                    <div className="modal-body">
                                        <div className="form-group">
                                            <label className="col-md-12">Date</label>
                                            <div className="col-md-12 input-group">
                                                <div className="input-group-addon"><i className="ti-time"></i></div>
                                                <input type="date" value={newOTRequest.date}
                                                       onChange={this.handleChangeDate}
                                                       className="form-control form-control-line" name="start"
                                                       disabled={newOTRequest.approve != -1}
                                                       id="start"/>
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <label className="col-md-12">OT Hour</label>
                                            <div className="col-md-3 input-group">
                                                <select className="form-control form-control-line"
                                                        name="ot_hour"
                                                        id="ot_hour"
                                                        onChange={this.handleChangeOTTime}>
                                                    <option value="1" selected={newOTRequest.ot_hour == 1}>1
                                                    </option>
                                                    <option value="2" selected={newOTRequest.ot_hour == 2}>2
                                                    </option>
                                                    <option value="3" selected={newOTRequest.ot_hour == 3}>3
                                                    </option>
                                                    <option value="4" selected={newOTRequest.ot_hour == 4}>4
                                                    </option>
                                                    <option value="5" selected={newOTRequest.ot_hour == 5}>5
                                                    </option>
                                                    <option value="6" selected={newOTRequest.ot_hour == 6}>6
                                                    </option>
                                                    <option value="7" selected={newOTRequest.ot_hour == 7}>7
                                                    </option>
                                                    <option value="8" selected={newOTRequest.ot_hour == 8}>8
                                                    </option>
                                                    <option value="9" selected={newOTRequest.ot_hour == 9}>9
                                                    </option>
                                                    <option value="10" selected={newOTRequest.ot_hour == 10}>10
                                                    </option>
                                                    <option value="11" selected={newOTRequest.ot_hour == 11}>11
                                                    </option>
                                                    <option value="12" selected={newOTRequest.ot_hour == 12}>12
                                                    </option>
                                                </select>
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <label className="col-md-12">Tasks</label>
                                            <div className="col-md-12 input-group">
                                                <div className="input-group-addon"><i
                                                    className="ti-pencil-alt"></i>
                                                </div>
                                                <input type="text" value={newOTRequest.reason}
                                                       onChange={this.handleChangeReason}
                                                       disabled={newOTRequest.approve != -1}
                                                       className="form-control form-control-line"
                                                       name="reason"
                                                       id="reason"/>
                                            </div>
                                        </div>
                                    </div>
                                    {newOTRequest.approve == -1 &&
                                        <div className="modal-footer">
                                            <button type="submit"
                                                    className="btn btn-info waves-effect waves-light">Update
                                            </button>
                                        </div>}
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            )
        } else {
            return (
                <div className="card">
                    <ToastContainer
                        position="top-right"
                        autoClose={5000}
                        hideProgressBar={false}
                        newestOnTop={false}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                    />
                    <div className="card-header text-center">
                        <div className="d-flex text-center">
                            <div className="m-r-20 align-self-center">
                                <img src="assets/images/clockin.png" alt="assets/images/clockin.png"
                                     width="25"/>
                            </div>
                            <h4 className="text-center m-t-10">OT Requests</h4>
                        </div>
                    </div>
                    <div className="card-body">
                        {email == currentUser.email && <>
                            <div className="text-center">
                                <button data-toggle="modal" data-target="#request-leave-modal"
                                        className="m-t-10 m-b-10 waves-effect waves-dark btn btn-primary btn-md btn-rounded">Create
                                    Request
                                </button>
                            </div>
                            <div>
                                <hr/>
                            </div>
                        </>}
                        <div>
                            {this.ShowRequests()}
                        </div>
                        <div id="request-leave-modal" className="modal fade" role="dialog"
                             aria-labelledby="requestLeaveModal" aria-hidden="true">
                            <form className="form-horizontal form-material" onSubmit={this.handleSubmit}>
                                <div className="modal-dialog">
                                    <div className="modal-content">
                                        <div className="modal-header">
                                            <h4 className="modal-title">Create OT Request</h4>
                                            <button type="button" className="close" data-dismiss="modal"
                                                    aria-hidden="true">×
                                            </button>
                                        </div>
                                        <div className="modal-body">
                                            <div className="form-group">
                                                <label className="col-md-12">Date</label>
                                                <div className="col-md-12 input-group">
                                                    <div className="input-group-addon"><i
                                                        className="ti-time"></i></div>
                                                    <input type="date" value={newOTRequest.date}
                                                           onChange={this.handleChangeDate}
                                                           className="form-control form-control-line"
                                                           name="start"
                                                           id="start"/>
                                                </div>
                                            </div>
                                            <div className="form-group">
                                                <label className="col-md-12">OT Hour</label>
                                                <div className="col-md-3 input-group">
                                                    <select className="form-control form-control-line"
                                                            name="ot_hour"
                                                            id="ot_hour"
                                                            onChange={this.handleChangeOTTime}>
                                                        <option value="1" selected={newOTRequest.ot_hour == 1}>1
                                                        </option>
                                                        <option value="2" selected={newOTRequest.ot_hour == 2}>2
                                                        </option>
                                                        <option value="3" selected={newOTRequest.ot_hour == 3}>3
                                                        </option>
                                                        <option value="4" selected={newOTRequest.ot_hour == 4}>4
                                                        </option>
                                                        <option value="5" selected={newOTRequest.ot_hour == 5}>5
                                                        </option>
                                                        <option value="6" selected={newOTRequest.ot_hour == 6}>6
                                                        </option>
                                                        <option value="7" selected={newOTRequest.ot_hour == 7}>7
                                                        </option>
                                                        <option value="8" selected={newOTRequest.ot_hour == 8}>8
                                                        </option>
                                                        <option value="9" selected={newOTRequest.ot_hour == 9}>9
                                                        </option>
                                                        <option value="10" selected={newOTRequest.ot_hour == 10}>10
                                                        </option>
                                                        <option value="11" selected={newOTRequest.ot_hour == 11}>11
                                                        </option>
                                                        <option value="12" selected={newOTRequest.ot_hour == 12}>12
                                                        </option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="form-group">
                                                <label className="col-md-12">Tasks</label>
                                                <div className="col-md-12 input-group">
                                                    <div className="input-group-addon"><i
                                                        className="ti-pencil-alt"></i>
                                                    </div>
                                                    <input type="text" value={newOTRequest.reason}
                                                           onChange={this.handleChangeReason}
                                                           className="form-control form-control-line"
                                                           name="reason"
                                                           id="reason"/>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="modal-footer">
                                            <button type="submit"
                                                    className="btn btn-danger waves-effect waves-light">Request
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>

                        <div id="update-request-leave-modal" className="modal fade" role="dialog"
                             aria-labelledby="updateLeaveModal" aria-hidden="true">
                            <form className="form-horizontal form-material" onSubmit={this.handleUpdate}>
                                <div className="modal-dialog">
                                    <div className="modal-content">
                                        <div className="modal-header">
                                            <h4 className="modal-title">Update OT Request</h4>
                                            <button type="button" className="close" data-dismiss="modal"
                                                    aria-hidden="true">×
                                            </button>
                                        </div>
                                        <div className="modal-body">
                                            <div className="form-group">
                                                <label className="col-md-12">Date</label>
                                                <div className="col-md-12 input-group">
                                                    <div className="input-group-addon"><i className="ti-time"></i></div>
                                                    <input type="date" value={newOTRequest.date}
                                                           onChange={this.handleChangeDate}
                                                           className="form-control form-control-line" name="start"
                                                           disabled={newOTRequest.approve != -1}
                                                           id="start"/>
                                                </div>
                                            </div>
                                            <div className="form-group">
                                                <label className="col-md-12">OT Hour</label>
                                                <div className="col-md-3 input-group">
                                                    <select className="form-control form-control-line"
                                                            name="ot_hour"
                                                            id="ot_hour"
                                                            onChange={this.handleChangeOTTime}>
                                                        <option value="1" selected={newOTRequest.ot_hour == 1}>1
                                                        </option>
                                                        <option value="2" selected={newOTRequest.ot_hour == 2}>2
                                                        </option>
                                                        <option value="3" selected={newOTRequest.ot_hour == 3}>3
                                                        </option>
                                                        <option value="4" selected={newOTRequest.ot_hour == 4}>4
                                                        </option>
                                                        <option value="5" selected={newOTRequest.ot_hour == 5}>5
                                                        </option>
                                                        <option value="6" selected={newOTRequest.ot_hour == 6}>6
                                                        </option>
                                                        <option value="7" selected={newOTRequest.ot_hour == 7}>7
                                                        </option>
                                                        <option value="8" selected={newOTRequest.ot_hour == 8}>8
                                                        </option>
                                                        <option value="9" selected={newOTRequest.ot_hour == 9}>9
                                                        </option>
                                                        <option value="10" selected={newOTRequest.ot_hour == 10}>10
                                                        </option>
                                                        <option value="11" selected={newOTRequest.ot_hour == 11}>11
                                                        </option>
                                                        <option value="12" selected={newOTRequest.ot_hour == 12}>12
                                                        </option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="form-group">
                                                <label className="col-md-12">Tasks</label>
                                                <div className="col-md-12 input-group">
                                                    <div className="input-group-addon"><i
                                                        className="ti-pencil-alt"></i>
                                                    </div>
                                                    <input type="text" value={newOTRequest.reason}
                                                           onChange={this.handleChangeReason}
                                                           disabled={newOTRequest.approve != -1}
                                                           className="form-control form-control-line"
                                                           name="reason"
                                                           id="reason"/>
                                                </div>
                                            </div>
                                        </div>
                                        {newOTRequest.approve == -1 &&
                                            <div className="modal-footer">
                                                <button type="submit"
                                                        className="btn btn-info waves-effect waves-light">Update
                                                </button>
                                            </div>}
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            )
        }
    }
}